import React from "react";
import { Link } from "react-router-dom";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      Así como otros cuentos que hacen parte del repertorio literario como <i>Cenicienta</i> o <i>Blancanieves</i>, este
      también habla de la historia de una niña que vivía con su madrastra.
    </p>
    <p className="content justified">
      Marta Rómpelo-Todo había perdido a su madre, quien la cuidaba desde el cielo, por lo que debía vivir con doña
      Policarpa del Pésimo Carácter, su cruel madrastra quien –como buena madrastra de cuento– la ponía a trabajar todo
      el día en los quehaceres de la casa. De vez en cuando, a Marta se le resbalaban los platos o las porcelanas de las
      manos.
    </p>
    <p className="content justified">
      El genio de su madrastra empeoraba algunos días. “Una mañana que doña Policarpa del Pésimo Carácter esperaba la
      visita de dos parientes ricos, sucedió entre ella y Marta Rómpelo-Todo lo que va a contarse”.
    </p>
    <p className="content justified">
      Resulta que doña Policarpa quería lucirse ante sus invitados, así que sacó una pieza de cristal y plata que había
      heredado de su abuela, y se la dio a Marta. Cuando la niña la tenía en sus manos, la madrastra pegó un grito, la
      niña se sobresaltó y la pieza de cristal se cayó y se rompió.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      Fue tanta la ira de doña Policarpa, que maldijo a Marta para que nunca más pudiera romper nada en su vida.
      “—Permítalo Dios—, respondió desde el cielo la voz de la madre angelical y buena de Marta”.
    </p>
    <p className="content justified">
      Fue así como la vida de Marta empezó a cambiar. Pasaron los días y Marta no podía romper los huevos para preparar
      la tortilla, ni romper la ramita de perejil en el jardín y tampoco romper el silencio para hablarle a su
      madrastra, ni romper su sueño para despertarla.
    </p>
    <p className="content justified">
      “El asunto exigía resoluciones radicales. Doña Policarpa del Pésimo Carácter no quería mantener en su casa una
      muchacha inútil y que sólo era una boca para comer, que no acertaba a hacer sus oficios y ni siquiera a decir una
      palabra”. Así que tomó las pertenencias de Marta y la sacó a la calle, creyendo que moriría de hambre.
    </p>
    <p className="content justified">
      Todo esto lo vió la madre de Marta, quien acabó con la maldición para que la niña pudiera valerse por sí misma sin
      necesidad de recibir los maltratos de su madrastra.
    </p>
  </div>
);

export const sections = (
  <div className="sectionsReview">
    <div className="sectionReview">
      <h3 className="review-title subtitle">Un cuento de hadas colombiano</h3>
      <p className="content justified">
        En esta narración llena de escenas tristes y violentas, Oswaldo Díaz Díaz toma de la tradición de los cuentos de
        hadas algunos elementos y los funde con aspectos del contexto colombiano. Se basa en una estructura básica,
        centrándose en la dificultosa convivencia entre una niña y su madrastra, luego una serie de conflictos y una
        resolución positiva y mágica de la situación.
      </p>
      <p className="content justified">
        En medio de estos hechos, nos encontramos elementos y objetos concretos que ubican al lector en tierras
        colombianas: el sembrado de perejil en el patio o el molinillo para romper la panela.
      </p>
      <p className="content justified">
        Además, en "Rómpelo-Todo" hay una conciencia narrativa explícita donde se indica que se cuentan hechos tristes
        para poder entender la verdadera maravilla del cuento.
      </p>
      <p className="content justified">
        Es interesante la naturalidad con la que se describen escenas muy crueles, lo que para algunos podría suponer no
        ser aptas para niños. Para Don Os estas situaciones hacen parte de la realidad de algunos niños, y él asume que
        están en la capacidad de entender cuando las palabras van acompañadas de un poco de fantasía, tal como sucede en
        el cuento <Link to="/obra/pomarrosa-en-el-parque?color=orange">“Pomarrosa en el parque”</Link>.
      </p>
    </div>
  </div>
);
